/* eslint-disable @typescript-eslint/no-explicit-any */
// import Qs from 'qs'
import service from '@/services/service'
// import { FieldName } from '@/interfaces/field-name.interface'

const resource = {
    main: 'services',
    module: 'report-agend-periodicities'
}
export class ReportAgendPeriodicitiesServices {
    public static getAgendPeriodicities () {
        return service.get(`${resource.main}/${resource.module}`)
    }
}
